import React from "react";

const KpiServices = () => {
  const services = [
    {
      title: "Customer Satisfaction & NPS Reports",
      imgSrc: "images/kpi1.png",
    },
    {
      title: "Market Trend Analysis Reports",
      imgSrc: "images/kpi2.png",
    },
    {
      title: "Product Performance KPIs",
      imgSrc: "images/kpi3.png",
    },
    {
      title: "Customer Engagement Reports",
      imgSrc: "images/kpi4.png",
    },
    {
      title: "Customer Retention & Churn KPIs",
      imgSrc: "images/kpi5.png",
    },
    {
      title: "Demographic & Psychographic Reports",
      imgSrc: "images/kpi6.png",
    },
  ];

  return (
    <section className="px-4 sm:px-6 lg:px-8 py-8 bg-white">
      <div className="font-poppins">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4">
          Our KPIs Reporting Services
        </h2>
        <p className="text-gray-600 mb-10 text-sm sm:text-base">
          Our Consumer Insights reporting is designed to offer in-depth,
          data-driven analysis across various consumer-focused KPIs, ensuring
          that you have the information needed to make strategic decisions with
          confidence.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="flex flex-col items-center p-4 sm:p-6 hover:shadow-lg transition-shadow duration-300 rounded-lg"
            >
              <div className="w-full h-48 sm:h-56 lg:h-64 relative">
                <img
                  src={service.imgSrc}
                  alt={service.title}
                  className="w-full h-full object-contain"
                  loading="lazy"
                />
              </div>
              <h3 className="text-base sm:text-lg font-semibold text-gray-800 text-center mt-4">
                {service.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default KpiServices;
